const MODULE_ALIASES: Record<string, string[]> = {
  medico: ['atestados_medicos', 'formularios', 'guias', 'convenios'],
  documentos: ['documentos', 'assinatura_digital'],
  estoque: ['estoque', 'produtos'],
  usuarios: ['usuarios', 'permissoes'],
  profissionais: ['profissionais', 'especialidades'],
  comunicacao: ['whatsapp', 'email'],
};

export const normalizeAllowedModules = (
  modules?: string[] | null,
): string[] => {
  if (!Array.isArray(modules)) {
    return [];
  }

  return Array.from(
    new Set(
      modules
        .flatMap((item) => {
          const normalizedItem = item.trim();
          return MODULE_ALIASES[normalizedItem] ?? [normalizedItem];
        })
        .filter(Boolean),
    ),
  );
};

export const hasAllowedModule = (
  modules: string[] | null | undefined,
  moduleKey: string,
): boolean => normalizeAllowedModules(modules).includes(moduleKey);
